import { render } from "./ForwordMsg.vue?vue&type=template&id=284e5641&scoped=true"
import script from "./ForwordMsg.vue?vue&type=script&lang=js"
export * from "./ForwordMsg.vue?vue&type=script&lang=js"

import "./ForwordMsg.vue?vue&type=style&index=0&id=284e5641&lang=scss&scoped=true"

import exportComponent from "D:\\Code\\MonsterView\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-284e5641"]])

export default __exports__